import React from 'react';

import Layout from '../../components/Layout';
import Seo from '../../components/Seo';
import CaseStudyRoll from '../../components/CaseStudyRoll/CaseStudyRoll';

export default class CaseStudyIndexPage extends React.Component {
  render() {
    return (
      <Layout>
        <Seo
          title="AI & ML Case Studies | Client Success Stories | Ortom"
          description="Real-world AI and machine learning case studies from Ortom. Healthcare, logistics, computer vision, NLP, and more."
          pathname="/case-studies/"
        />
        <section className="section">
          <div className="container">
            <div className="content">
              <CaseStudyRoll />
            </div>
          </div>
        </section>
      </Layout>
    );
  }
}
